import styled, {css} from 'styled-components'

export const StyledDashboardSectionContainer = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 6}px;
        padding: ${spacing * 6}px;
        width: 100%;
    `
)
